<template>
  <div class="home">
    <Messages :code='code' showAllUsers v-show="isSignedIn && isValidCode"/>
    <Footer/>
  </div>
</template>

<script>
// @ is an alias to /src
import Messages from '@/components/Messages.vue';
import Footer from '@/components/Footer.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'AllMessages',
  components: {
    Messages,
    Footer,
  },
  props: {
    code: {
      type: String,
      required: false,
    },
  },
  computed: {
    ...mapGetters({ isSignedIn: 'isSignedIn', isValidCode: 'isValidCode' }),
  },
  methods: {
    ...mapActions(['validateCode', 'signInAnonymously']),
  },
  created() {
    this.signInAnonymously();
  },
  beforeUpdate() {
    if (this.isSignedIn && this.isValidCode === false) {
      this.validateCode(this.code);
    }
  },
};
</script>

<style scoped>
.home {
  height: 100%;
  padding: 0;
  margin: 0;
}
</style>
